export const ERRORS = {
    HTTP_BAD_REQUEST: 'Solicitud incorrecta',
    HTTP_FORBIDDEN_RESOURCE: 'No tiene permisos para realizar la operación solicitada.',
    HTTP_SERVER_ERROR:
        'Ha ocurrido un error y no hemos logrado realizar su operación, intentelo de nuevo más adelante.',
    NOT_FOUND: 'Recurso no encontrado',
    HTTP_TIMEOUT: 'Timeout',
    HTTP_UNAUTHIRIZED: 'No autorizado',
    DEFAULT_MESSAGE: '¡Up! Algo salió mal.',
};

export const STATUS_CODE_ERRORS = {
    400: ERRORS.HTTP_BAD_REQUEST,
    401: ERRORS.HTTP_UNAUTHIRIZED,
    404: ERRORS.NOT_FOUND,
    500: ERRORS.HTTP_SERVER_ERROR,
    403: ERRORS.HTTP_FORBIDDEN_RESOURCE,
    408: ERRORS.HTTP_TIMEOUT,
};

export const CODE_ERRORS: Record<string, string> = {
    'max-limit-reached': 'Máximo de límite superado, vuelve a intenter mañana o contacte el administrador.',
    'newpwd-error': 'Usuario nuevo, aún tiene pendiente acceder al correo de confirmación',
    'user-exists': 'El usuario ya existe.',
    'MERCHANT_STORE_NOT_FOUND': 'La tienda por defecto no se encuentra en la lista de tiendas del comercio',
    'PREPROCESSOR_SERVER_ERROR': 'Error interno del servicio de procesamiento. Por favor, intente nuevamente más tarde.',
};
